import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { checkoutService } from 'services';
import { Cart, SaveShippingMethodParams } from 'types';
import { displayNotification, pushToGTM } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useSaveOrderShippingMethod = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    ({ setOrderStep, freeShippingCoupon }: SaveShippingMethodParams) => {
      return checkoutService.saveOrderShippingMethod(freeShippingCoupon);
    },
    {
      onSuccess: async (data, variables, context) => {
        const currentCart = queryClient.getQueryData<Cart>(
          ServerStateKeysEnum.userCurrentCart
        );

        if (currentCart?.checkoutStates.includes('payment')) {
          variables.setOrderStep('payment');
        } else {
          variables.setOrderStep('confirm');
        }
        if (currentCart) {
          pushShippingInfoEventToGTM(currentCart);
        }

        queryClient.invalidateQueries([ServerStateKeysEnum.userCurrentCart]);

        displayNotification(i18n['Shipping method saved Successfully']);
      },
      onError: e => {
        const error = e as { response?: { data?: any } };
        if (!error.response?.data) {
          displayNotification(
            i18n['Failed to save order shipping method!'],
            'danger'
          );
        }
      },
    }
  );
};

const pushShippingInfoEventToGTM = (data: Cart) => {
  const lineItems = data.lineItems.map(currentLineItem => {
    return {
      item_id: currentLineItem.slug,
      item_name: currentLineItem.name,
      affiliation: 'Global Store NA',
      price: currentLineItem.price,
      currency: data.currency,
      quantity: currentLineItem.quantity,
    };
  });

  pushToGTM('add_shipping_info', {
    ecommerce: {
      currency: data.currency,
      value: data.total,
      shipping_tier: 'UPS Ground',
      items: lineItems,
    },
  });
};
